export default {
  nav: {
    home: '首页',
    products: '产品',
    solutions: '解决方案',
    ecosystem: '生态系统',
    about: '关于我们',
    start: '开始使用'
  },
  sections: {
    hero: {
      title: '构建去中心化的未来',
      subtitle: 'KOMA致力于打造新一代区块链基础设施，为去中心化应用提供高性能、安全可靠的运行环境',
      whitepaper: '查看白皮书',
      join: '加入社区',
      features: {
        performance: {
          title: '高性能交易',
          description: '支持每秒数万笔交易处理，满足企业级应用需求'
        },
        community: {
          title: '社区驱动',
          description: '由全球社区共同参与治理，实现真正的去中心化'
        },
        innovation: {
          title: '创新技术',
          description: '采用最前沿的区块链技术，打造安全可靠的基础设施'
        },
        national: {
          title: '阿斯塔国际',
          description: '大业纵横基金会国际法务部〖国际法务执行机构〗'
        },
        huge: {
          title: '大業縱橫',
          description: '大业纵横基金会国际业务部〖国际业务执行机构〗'
        },
        dragon: {
          title: '龍鳳呈祥',
          description: '创新与传统的完美融合，开创区块链新纪元'
        }
      }
    },
    vision: {
      title: '为什么选择 KOMA',
      subtitle: '我们提供全方位的区块链解决方案，从技术架构到应用场景，为您的数字资产管理提供最佳选择',
      features: {
        security: {
          title: '安全可靠',
          description: '采用多重签名和智能合约审计，确保资产安全。系统运行稳定，24/7 技术支持。'
        },
        strategy: {
          title: '智能策略',
          description: '基于机器学习的智能交易策略，自动识别市场机会，优化投资组合。'
        },
        performance: {
          title: '高性能',
          description: '支持每秒数万次交易处理，毫秒级延迟，满足专业交易需求。'
        }
      }
    },
    token: {
      title: '生态系统',
      subtitle: 'KOMA 生态系统涵盖 DeFi、NFT、DAO 等多个领域，为用户提供全方位的区块链服务',
      learnMore: '了解更多',
      features: {
        defi: {
          title: 'DeFi 金融',
          description: '去中心化借贷、流动性挖矿、收益聚合器'
        },
        nft: {
          title: 'NFT 市场',
          description: '数字艺术品交易、游戏资产、虚拟物品'
        },
        dao: {
          title: 'DAO 治理',
          description: '社区治理、提案投票、激励机制'
        },
        gamefi: {
          title: 'GameFi',
          description: '区块链游戏、游戏资产交易、Play to Earn'
        }
      }
    },
    economy: {
      title: '代币经济模型',
      subtitle: 'KOMA 代币是生态系统的核心，用于治理、质押和交易手续费',
      details: {
        title: '代币分配详情',
        ecosystem: '生态基金',
        team: '团队持有',
        private: '私募',
        public: '公募',
        community: '社区激励'
      }
    },
    resonance: {
      title: '发展路线图',
      subtitle: 'KOMA 的发展计划和重要里程碑',
      q4: {
        item1: '完成核心技术架构开发',
        item2: '发布测试网络',
        item3: '完成安全审计'
      },
      q1: {
        item1: '主网上线',
        item2: '代币发行',
        item3: 'DeFi 生态建设'
      },
      q2: {
        item1: 'NFT 市场 launch',
        item2: 'GameFi 平台上线',
        item3: '跨链桥部署'
      },
      q3q4: {
        item1: 'Layer2 扩展方案',
        item2: 'DAO 治理系统升级',
        item3: '全球生态扩张'
      }
    },
    tech: {
      team: {
        title: '技术团队',
        subtitle: '由区块链行业资深专家组成的核心团队',
        membersOne: {
          name: '张三',
          title: '技术总监',
          description: '前某知名区块链公司技术负责人，拥有丰富的区块链开发经验'
        },
        membersTwo: {
          name: '李四',
          title: '架构师',
          description: '专注于区块链底层技术研究，参与多个公链项目开发'
        },
        membersThree: {
          name: '王五',
          title: '安全专家',
          description: '区块链安全领域专家，曾负责多个大型项目的安全审计'
        },
        membersFour: {
          name: '赵六',
          title: '产品经理',
          description: '拥有丰富的区块链产品经验，专注于用户体验优化'
        }
      },
      partners: {
        title: '合作伙伴',
        subtitle: '与行业领先企业建立战略合作'
      },
      cta: {
        title: '加入我们',
        subtitle: '一起构建区块链的未来',
        startButton: '开始使用',
        docsButton: '查看文档'
      }
    },
    footer: {
      slogan: '构建去中心化的未来',
      product: {
        title: '产品',
        architecture: '技术架构',
        docs: '开发文档',
        api: 'API 接口'
      },
      resources: {
        title: '资源',
        blog: '博客',
        community: '社区',
        help: '帮助中心'
      },
      contact: {
        title: '联系我们',
        twitter: 'Twitter',
        discord: 'Discord',
        telegram: 'Telegram'
      },
      copyright: '© 2024 KOMA. All rights reserved.'
    }
  }
} 